//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 按需引入部分组件
import action from './action';
import { commentItem } from 'components/app';
import { List, Icon, Toast, Loading } from 'vant';
export default {
  name: 'commentPage',
  props: ['params'],
  metaInfo() {
    return {
      title: this.pageTitle
    };
  },
  components: {
    List, Icon, Toast, Loading
  },
  /* created: async function () {
    await this.getInfo();
    // wx.config({
    //   debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //   appId: '', // 必填，公众号的唯一标识
    //   timestamp: , // 必填，生成签名的时间戳
    //   nonceStr: '', // 必填，生成签名的随机串
    //   signature: '',// 必填，签名
    //   jsApiList: ['previewImage', 'chooseImage'] // 必填，需要使用的JS接口列表
    // });
    wx.config({
      "timeStamp": "1541499520",
      "package": "prepay_id=null",
      "paySign": "1F8C3F04332D5242ED65520BE4816587",
      "appId": "wx19bdde06f1dad969",
      "signType": "MD5",
      "nonceStr": "1541499520980"
    } )
    console.log('-----------this', this)
  }, */
  data() {
    return {
      pageTitle: '全部评论',
      commArr: [1,2,3],
      evaluation: '',
      loading: false,
      finished: false,
      materialId: undefined,
      commentTotal: 0,
      commentData: [],
      page: 1,
      pageSize: 20,
      replyName: undefined,
      materialCommentId: undefined,
      firstCommentId: undefined,
      commentType: 1,
      timer: false,
      commId: undefined,
      replyindex: undefined,
      replyUserName: undefined,
      hotCommentList: {
        code: undefined,
        data: [],
        msg: undefined
      },
      isHot: false,
      sendStatus: false,
    }
  },
  methods: {
    ...action,
  },
  async created() {
    this.init();
  },
  mounted() {
    // console.log('=================创建全部评论');
    // this.materialId = this.$route.params.id;
    // const materialId = this.$route.params.id;
    // this.hotCommentList = this.getHotCommentList({materialId});
    // this.getComment();
  },
  // 复用组件，监听路由变化
  beforeRouteUpdate (to, from, next) {
    console.log('=================路由变化了',to.params,to.query);
    // 防抖
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      if (to.query.name) {
      // 重置数据
      this.commentData = [];
      this.hotCommentList= {
        code: undefined,
        data: [],
        msg: undefined
      };
      this.commentTotal = 0;
      this.page = 1;
      this.replyindex = undefined;
      this.replyUserName = undefined;
      this.finished = false;
      this.evaluation = '';
      this.materialCommentId = to.params.commId;
      this.getCommentDetail();
      this.handleRelpy(to.query.name, this.materialCommentId, this.materialCommentId, 0);
      this.replyName = to.query.name;
      this.commId = to.params.commId;
      next()
      } else {
        // 重置数据
        this.replyName = undefined;
        this.commentData = [];
        this.hotCommentList= {
          code: undefined,
          data: [],
          msg: undefined
        };
        this.commentTotal = 0;
        this.replyindex = undefined;
        this.replyUserName = undefined;
        this.page = 1;
        this.commId = undefined;
        this.finished = false;
        this.evaluation = '';
        this.materialCommentId = undefined;
        this.firstCommentId = undefined;
        this.materialId = to.params.id;
        this.getComment();
        document.querySelector('#replyInput').setAttribute('placeholder', `社区逢知己，不如聊一句`);
      }
    }, 100);
  }
}



// WEBPACK FOOTER //
// ./src/module/app/commentPage/page.vue